module.exports = __webpack_public_path__ + "img/clock.e9cf9ed1.svg";